//import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import {sortStationsByNumber} from '../../libs/utility';
import {gridMargin} from "./general";

export default class FMPStationSelect extends PureComponent {
	render () {
		const {
			label, value, path, onChange, stations,
			error, helpText, md, readOnly,contained
		} = this.props;

		const hasError = !!error;
		const _onChange = event => {
			onChange(event.target.value, path);
		};

		const sorted = sortStationsByNumber(stations);

		const content = (
			<Grid item xs={12} md={md} style={gridMargin}>
				<FormControl fullWidth={true} error={hasError} style={{textAlign:'left'}}>
					<InputLabel htmlFor={path}>{label}</InputLabel>
					<Select
						value={value}
						onChange={_onChange}
						input={<Input id={path} readOnly={readOnly} />}
					>

						{sorted.map((station, i) => {
							const { stationId, number, name} = station;
							return (
								<MenuItem key={i} value={stationId}>
									{number} - {name}
								</MenuItem>
							);
						})}
					</Select>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{(helpText && !hasError) && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		);

		if (contained) {
			return (
				<Grid spacing={2} container>
					{content}
				</Grid>
			);
		} else {
			return content;
		}

	}
}

FMPStationSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,
	readOnly : PropTypes.bool,

	stations : PropTypes.array.isRequired,
	md : PropTypes.number,
	helpText : PropTypes.string,
	contained : PropTypes.bool,

};


FMPStationSelect.defaultProps =  {
	label : 'Station',
	md : 12,
	contained : true,
};